import * as React from "react";
import type { SVGProps } from "react";
const MedicClinic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_7581)">
      <path
        fill="currentColor"
        d="M23.9914 11.9798c0 .75-.625 1.3375-1.3333 1.3375h-1.3334l.0292 6.675c.0083 1.4792-1.1875 2.6792-2.6667 2.6792h-13.35c-1.4708 0-2.6666-1.1958-2.6666-2.6667v-6.6833H1.3372c-.75 0-1.3333-.5833-1.3333-1.3375 0-.375.125-.7083.4167-1l10.6791-9.3167c.2917-.2916.625-.3333.9167-.3333s.625.0833.875.2916l4.4417 3.9042V4.0007c0-.7376.5958-1.3334 1.3333-1.3334h1.3333a1.332 1.332 0 0 1 1.3334 1.3334v5.0416l2.2 1.9334c.3333.2916.5.625.4583 1zM11.3331 9.334c-.3667 0-.6667.3-.6667.6667v2h-2c-.3667 0-.6667.3-.6667.6666v1.3334c0 .3666.3.6666.6667.6666h2v2c0 .3667.3.6667.6667.6667h1.3333c.3667 0 .6667-.3.6667-.6667v-2h2c.3666 0 .6666-.3.6666-.6666v-1.3334c0-.3666-.3-.6666-.6666-.6666h-2v-2c0-.3667-.3-.6667-.6667-.6667z"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_7581">
        <path fill="transparent" d="M0 1.3335h24v21.3333H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default MedicClinic;
